import { useEffect, useState, createContext, useContext, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SavedContext = createContext(null);

export function SavedProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState(new Set());

  const refresh = useCallback(async () => {
    if (!user) { setIds(new Set()); return; }
    try {
      const { data } = await api.get("/saves/ids");
      setIds(new Set(data.saved_ids || []));
    } catch { setIds(new Set()); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async (listing_id) => {
    if (!user) return false;
    if (ids.has(listing_id)) {
      await api.delete(`/saves/${listing_id}`);
      setIds((prev) => { const n = new Set(prev); n.delete(listing_id); return n; });
      return false;
    } else {
      await api.post("/saves", { listing_id });
      setIds((prev) => new Set(prev).add(listing_id));
      return true;
    }
  };

  return (
    <SavedContext.Provider value={{ ids, toggle, refresh }}>{children}</SavedContext.Provider>
  );
}

export const useSaved = () => useContext(SavedContext);
